import VueRouter, { Route } from 'vue-router';
import { magic } from '@gig/magic-sdk';
import { BANK_ID_STEPS } from '@gig/magic-account/dist/components/bank-id/sign-up/sign-up.constants';

import { RouteName } from '../../../routes/routes.constants';
import { BRITE_AUTH_SESSION_KEY, getModals } from '../../../util';

const protectedBriteSteps = [
    BANK_ID_STEPS.STEP_BRITE,
    BANK_ID_STEPS.STEP_DETAILS,
    BANK_ID_STEPS.STEP_VERIFICATION,
    BANK_ID_STEPS.STEP_FINAL,
];

async function shouldForceBriteStep(): Promise<boolean> {
    if (!magic.session.getUser()) {
        return false;
    }

    try {
        if (window.localStorage.getItem(BRITE_AUTH_SESSION_KEY) !== 'true') {
            return false;
        }

        const profile = await magic.methods.users.getProfile();

        return !profile?.mobile;
    } catch {
        return false;
    }
}

function isProtectedBriteRoute(route: Route): boolean {
    return (
        (route.name === RouteName.SIGN_UP_HYBRID ||
            route.name === RouteName.SIGN_UP_BANKID) &&
        protectedBriteSteps.includes(route.params.step as BANK_ID_STEPS)
    );
}

function hasProtectedBriteRoute(route: Route, router: VueRouter): boolean {
    return [route, ...getModals(route.query, router)].some(isProtectedBriteRoute);
}

export function initBriteAuthGuard(router: VueRouter) {
    router.beforeEach(async (to, _, next) => {
        if (
            !(await shouldForceBriteStep()) ||
            hasProtectedBriteRoute(to, router)
        ) {
            return next();
        }

        return next({
            name: RouteName.SIGN_UP_HYBRID,
            params: {
                ...to.params,
                step: BANK_ID_STEPS.STEP_BRITE,
            },
        });
    });
}
